export interface DailyChallenge {
  readonly id: string
  readonly date: string
  readonly seed: number
  readonly expiresAt: string
}

function hashSeed(value: string): number {
  let hash = 0x811c9dc5
  for (let index = 0; index < value.length; index += 1) {
    hash ^= value.charCodeAt(index)
    hash = Math.imul(hash, 0x01000193)
  }
  return hash >>> 0
}

export function createDailyChallenge(now = new Date(), salt = 'neon-descent-daily-v2'): DailyChallenge {
  const date = now.toISOString().slice(0, 10)
  const expiresAt = new Date(`${date}T00:00:00.000Z`)
  expiresAt.setUTCDate(expiresAt.getUTCDate() + 1)
  return {
    id: `daily-${date}`,
    date,
    seed: hashSeed(`${salt}:${date}`),
    expiresAt: expiresAt.toISOString(),
  }
}
